<template>
    <div class="home">
        <p :class="music ? 'music zhuan' : 'music'" @click="stopmusic"></p>
        <audio id="audio" loop="loop" :src="require('@/static/bgm.mp3')"></audio>
        <img src="../static/title.png" class="title" alt="">
        <img src="../static/words.png" class="thewords" alt="" v-show="thewords">
        <img src="../static/thegif.gif" class="thegif" alt="">
        <div class="words" v-html="words" v-show="show">
        </div>

        <video-player class="video-player vjs-custom-skin mp4-1" ref="mp4_1" :playsinline="true" :options="mp4_1"
            @ended="onPlayerEnded($event)" @play="onPlayerPlay($event)" @pause="onPlayerPause($event)" v-show="showmp4">
        </video-player>

        <div v-if="selectid == 0">
            <img src="../static/ewm.png" class="ewm" alt="">
            <p class="tips">扫码进入官网</p>
        </div>
        <div v-if="selectid == 2">
            <img src="../static/ewm2.png" class="ewm" alt="">
            <p class="tips">扫码进入官网</p>
        </div>
        <div v-if="selectid == 3">
            <img src="../static/ewm3.png" class="ewm" alt="">
            <p class="tips">扫码添加微信</p>
        </div>
        <div v-if="selectid == 6">
            <img src="../static/ewm6.jpg" class="ewm" alt="">
            <p class="tips">微信扫码入群咨询</p>
        </div>
        <div v-if="selectid == 8">
            <img src="../static/ewm8.jpg" class="ewm" alt="">
            <p class="tips">扫码看溯源视频</p>
        </div>
        <div v-if="selectid == 10">
            <img src="../static/ewm10.jpg" class="ewm" alt="">
            <p class="tips">扫码进入公众号</p>
        </div>
        <div v-if="selectid == 11">
            <img src="../static/ewm11.jpg" class="ewm" alt="">
            <p class="tips">扫码进入公众号</p>
        </div>
        <div v-if="selectid == 12">
            <img src="../static/ewm12.jpg" class="ewm" alt="">
            <p class="tips">扫码进入公众号</p>
        </div>
        <div v-if="selectid == 14">
            <img src="../static/ewm14.jpg" class="ewm" alt="">
            <p class="tips">扫码关注公众号</p>
        </div>
        <div v-if="selectid == 15">
            <img src="../static/ewm15.jpg" class="ewm" alt="">
            <p class="tips">扫码关注公众号</p>
        </div>
        <div v-if="selectid == 18">
            <img src="../static/ewm18.jpg" class="ewm" alt="">
            <p class="tips">扫码关注公众号</p>
        </div>


        <img src="../static/logo1.png" class="logo1" alt="">
        <img src="../static/logo.png" class="logo" alt="">
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            showmp4: false,
            start:true,
            thewords: false,
            mp4_1: {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: "zh-CN",
                aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                    {
                        type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                        src: require("../static/mp4_1.mp4"), //url地址
                    },
                ],
                poster: require("../static/mp4_1.png"), //你的封面地址
                // width: document.documentElement.clientWidth, //播放器宽度
                notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: false, // 当前时间和持续时间的分隔符
                    durationDisplay: false, // 显示持续时间
                    remainingTimeDisplay: false, // 是否显示剩余时间功能

                    fullscreenToggle: true, //全屏按钮
                },
            },
            music: true,
            selectid: 0,
            words: '<p>(定制祝福示例)</p><p class="title-words">尊敬的客户及合作伙伴们：</p><p>在这辞旧迎新的美好时刻，[您的名称]向您及家人致以最诚挚的祝福和最温暖的拥抱！</p><p> 过去的一年里，是您的支持与信任，如同璀璨星辰，照亮了我们前行的道路。每一份合作，每一次交流，都凝聚成我们共同的记忆与成就。在此，我们衷心感谢您的一路相伴，是您的鼓励与鞭策，让我们不断超越，勇攀高峰。</p><p> 新的一年，我们将以更加饱满的热情，更加专业的态度，继续秉承“创新、卓越、共赢”的核心价值观，为您提供更优质的产品与服务。[您的名称]承诺，将携手每一位尊贵的您，共同开启一段充满希望与挑战的新征程，共创辉煌未来！</p><p> 愿新年的钟声敲响幸福的序曲，为您的家庭带来和谐美满，为您的事业插上腾飞的翅膀。愿健康、快乐、成功与您常伴，每一天都充满阳光与喜悦。</p><p>再次祝愿您及家人新春快乐，身体健康，万事如意，蛇年大吉！</p><p class="end-words">——[您的名称] 敬上</p>'
        }
    },
    methods: {
        stopmusic() {
            let audio = document.getElementById("audio");
            if (this.music == true) {
                this.music = false;
                audio.pause();
            } else {
                this.music = true;
                audio.volume = 0.2

                audio.play();
            }
        },
        onPlayerPlay(e, a) {
            let audio = document.getElementById("audio");
            audio.pause();
        },
        onPlayerEnded(e) {
            console.log("播放结束", e);
            let audio = document.getElementById("audio");
 
            if (this.music == true) {
                audio.volume = 0.2;
                audio.play();

            } else {

                audio.pause();
            }

        },
        onPlayerPause(e) {
            let audio = document.getElementById("audio");


            if (this.music == true) {
                audio.volume = 0.2;
                audio.play();

            } else {

                audio.pause();
            }

        },
        androidplay() {
            if (navigator.userAgent.indexOf("Android") > 0) {
                //如果是Android的话，在判断是否是微信端打开链接
                function is_weixn() {
                    var ua = navigator.userAgent.toLowerCase();
                    if (ua.match(/MicroMessenger/i) == "micromessenger") {
                        return true;
                    } else {
                        return false;
                    }
                }
                //如果是在Android端微信打开 触摸播放
                if (is_weixn()) {
                    document.addEventListener('touchstart', () => {

                        if (this.music&&this.start) {
                            this.start=false
                            document.getElementById('audio').volume = 0.2;
                            document.getElementById('audio').play();
                        }


                    })
                } else {
                }
            }
        },

        scrolling() {
            // 滚动条距文档顶部的距离
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            // 滚动条滚动的距离
            let scrollStep = scrollTop - this.oldScrollTop;
            // console.log("header 滚动距离 ", scrollTop);
            if (scrollTop > 0 && !this.mp4) {
                if (this.music&&this.start) {
                    this.start=false
                    document.getElementById('audio').volume = 0.2
                    document.getElementById('audio').play();
                }
            }

            // 更新——滚动前，滚动条距文档顶部的距离
            this.oldScrollTop = scrollTop;

            //变量windowHeight是可视区的高度
            let windowHeight =
                document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            let scrollHeight =
                document.documentElement.scrollHeight || document.body.scrollHeight;

            //滚动条到底部的条件
            if (scrollTop + windowHeight == scrollHeight) {
                //你想做的事情
                console.log("header  你已经到底部了");
            }
            //   if (scrollStep < 0) {
            //     console.log("header 滚动条向上滚动了！");
            //   } else {
            //     console.log("header  滚动条向下滚动了！");
            //   }
            // 判断是否到了最顶部
            if (scrollTop <= 0) {
                console.log("header 到了最顶部")
            }
        }
    },
    mounted() {
        console.log(this.$route.query.id, "id");
        if (this.$route.query.id) {
            this.selectid = this.$route.query.id
            console.log(this.selectid, 55);

        }
        //<p></p><p class="end-words">——明呈·云泰璟园 敬上</p>
        if (this.$route.query.id == 1) {
            this.mp4_1.sources[0].src = require("../static/m1.mp4")
            this.mp4_1.poster = require("../static/m1.jpg")
            this.words = '<p class="title-words">尊敬的客户及合作伙伴们：</p><p> 岁序常易，华章日新。当时间勾勒出新的轮廓，二〇二五农历新年如期而至。值此新春佳节来临之际，明呈·云泰璟园向客户朋友、合作伙伴、广大员工及其家属致以节日的问候和新春的祝福！</p><p> 2024年，行行重行行，这一年，有竞争下的忙碌，有变局中的求新，有寻常里的坚守。在时代与行业的巨变中，我们无法忽视严峻复杂的政策、市场环境带来的未知、挑战、不乏焦虑，大家感同身受，但我们知难不畏难。关关难过过关关，越过越好！2024，历经风雨，我们仍然在这里！</p><p> 这一年，不管市场如何变化，坚持做好产品、坚守品质、尊重客户，是明呈·云泰璟园持续履行的长期主义，也是我们最大的信心与底气！过去的一年，对于云泰璟园来说是硕果累累的一年。住宅方面，我们共同见证了明呈·云泰璟园项目的交付后的美好新生活。每一家每一户的欢声笑语，都是对我们工作的最大赞许。我们深知，是您们的信任与支持，让我们有了为每一位业主提供高品质服务的动力。商业配套方面，我们见证了明呈·方圆荟这一路走来直至2024年底的盛大启幕，经历了成功、沉寂、再到改变与新生的故事，不仅生动展现了商业领域的风云变幻，也凝聚了明呈地产商业运营的宝贵智慧与实践经验。</p><p> 如今，明呈·云泰璟园已经呈现出一片生机勃勃的景象，优美的园林、宽敞的住宅、醇熟的配套。我们深知品质是企业的生命线，也是赢得业主信任的核心。在未来的日子里,我们将继续坚守品质初心，不断提升品质与服务，为您创造更加舒适、安全、有品质的居住环境。</p><p>春山在望，未来可期。让我们满怀上一年的热爱，奔赴下一年的山海；让我们携手并肩、奋楫向前。新的一年，祝愿明呈·云泰璟园的广大业主、合作伙伴、员工家人们静宁见春，祉猷并茂，顺遂无虞，皆得所愿。</p><p class="end-words">——明呈·云泰璟园 敬上</p>'

        } else if (this.$route.query.id == 2) {
            this.mp4_1.sources[0].src = require("../static/m2.mp4")
            this.mp4_1.poster = require("../static/m2.jpg")
            this.words = '<p class="title-words">全国经销商家人们：</p><p>值此新春佳节之际，我怀揣着一颗热忱之心，代表正福隆壹墅大门，向您及家人致以最诚挚的问候！</p><p>过去的一年里，感谢您对我们的支持与信任，我们共同经历了许多难忘的时刻。每一次的挑战，都让我们更加坚韧；每一次的成功，都让我们更加自信。您的关怀与帮助是我们不断前行的动力。</p><p>正福隆壹墅大门已经走过15个年头，主要产品有全铝别墅大门、精雕铸铝装甲门、精品城市小非标门。从一家1000㎡的小企业，到拥有30000㎡的现代化生产车间，我们靠的是一步一个脚印踏踏实实的努力。</p><p>当下环境大浪淘沙，不进则退。正福隆壹墅大门以创新为引擎，以品质为基石，不惧风雨，踏浪前行。截至目前，企业共有员工近200人，管理人员20余人，其中90%都是跟随正福隆成长起来的老员工。</p><p>2022年至今，企业先后投入1200万元进行设备改造和产品研发，目前拥有3条行业内顶尖的大规模、现代化生产线，实现了年产别墅铝卡大门4万樘。这些年，公司订单量每年保持40%以上的增长，成为行业内颇具成长力的企业。</p><p>新的一年，我们将继续秉承初心，砥砺前行，期待与您共创更加辉煌的未来。愿我们的合作更加紧密，友谊更加深厚。</p><p class="end-words">——正福隆壹墅大门 敬上</p>'
        }
        else if (this.$route.query.id == 3) {
            this.mp4_1.sources[0].src = require("../static/m3.mp4")
            this.mp4_1.poster = require("../static/m3.jpg")
            this.words = '<p class="title-words">尊敬的客户及合作伙伴们：</p><p>金华清和园供应链有限公司是一家从事供应链管理服务、货物仓储服务、国内货物运输代理等业务的公司。公司经营范围包括：供应链管理服务；普通货物仓储服务；国内货物运输代理；低温仓储；水产品、农副产品、食用农产品、蔬果类产品批发零售。</p><p>在这辞旧迎新的美好时刻，清和园供应链携全体员工向您及家人致以最诚挚的祝福！过去一年，承蒙您的信任与支持，清和园供应链得以稳步前行，佳绩斐然。新岁启封，我们将继续秉持初心，精优服务，愿与您携手共进，同赴新程。衷心祝您和您的家人新春快乐，阖家团圆，身体安康，万事胜意！祥龙昂首留祥瑞，灵蛇舞动送福长，愿新岁的阳光照亮您的梦想，幸福与您岁岁常伴！</p><p class="end-words">——清和园 敬上</p>'
        }
        else if (this.$route.query.id == 4) {
            this.mp4_1.sources[0].src = require("../static/m4.mp4")
            this.mp4_1.poster = require("../static/m4.jpg")
            this.words = '<p class="title-words">尊敬的客户及合作伙伴们：</p><p>在这辞旧迎新的美好时刻，中国铁塔金华市分公司向您及家人致以最诚挚的祝福和最温暖的拥抱！</p><p>十年光华，金华铁塔践行网络强国使命，坚守“凡有人烟处，皆有通信塔”的承诺，为金华八婺大地通信网络的无缝覆盖奠定坚实基础，将1.8万座“通信塔”升级成“数字塔”，数智赋能千行百业。</p><p>过去的一年里，是您的支持与信任，如同璀璨星辰，照亮了我们前行的道路。每一份合作，每一次交流，都凝聚成我们共同的记忆与成就。在此，我们衷心感谢您的一路相伴，是您的鼓励与鞭策，让我们不断超越，勇攀高峰。</p><p> 新的一年，我们将以更加饱满的热情，更加专业的态度，继续秉承“创新、卓越、共赢”的核心价值观，为您提供更优质的产品与服务。我们承诺，将携手每一位尊贵的您，共同开启一段充满希望与挑战的新征程，共创辉煌未来！</p><p>愿新年的钟声敲响幸福的序曲，为您的家庭带来和谐美满，为您的事业插上腾飞的翅膀。愿健康、快乐、成功与您常伴，每一天都充满阳光与喜悦。</p><p>再次祝愿您及家人新春快乐，身体健康，万事如意，蛇年大吉！</p><p class="end-words">——中国铁塔金华市分公司 敬上</p>'
        }
        else if (this.$route.query.id == 5) {
            this.mp4_1.sources[0].src = require("../static/m5.mp4")
            this.mp4_1.poster = require("../static/m5.jpg")
            this.words = '<p class="title-words">尊敬的各位同仁、全体员工们：</p><p>岁月如虹，流年似锦。伴随着新年的爆竹声声，值此新春佳节之际，天开公司谨向各位同仁，向关心支持供公司发展的各界朋友，致以节日的问候和新春的祝福！</p><p> 奋斗笃行，行业引领。自1985年创立以来，天开公司于1986年研发出国内第一块防静电地板，后又率先研制生产国内第一卷防静电PVC卷材，并先后研制生产多款防静电PVC地板、商用同质PVC卷材等国内领先的高新技术产品，多次获得国家、省、市等各级单位的认证。产品已被3000多家海内外知名企业所采用。</p><p> 未来属于奋斗者，时光不负实干家。感谢全体天开员工的付出，你们是企业前进的最强基石，天开大步迈进的道路上有你们奉献的身影。我们深知，每一次进步都离不开广大客户的信赖和支持，每一次前进的背后都是全体员工的努力和奉献。在此，我们向所有关心和支持天开公司发展的朋友们表示衷心的感谢！</p><p>踌躇满志再出发，沐雨栉风破浪行。新的一年，天开与您携手并进，一路逐梦追光，共同书写崭新篇章。愿广大客户事业蒸蒸日上，财源广进；愿全体员工家庭幸福，身体健康。</p><p>最后，衷心祝愿大家新春快乐，阖家幸福，万事如意！</p><p class="end-words">——金华天开电子材料有限公司 敬上</p>'
        }
        else if (this.$route.query.id == 6) {
            this.mp4_1.sources[0].src = require("../static/m6.mp4")
            this.mp4_1.poster = require("../static/m6.jpg")
            this.words = '<p class="title-words">尊敬的各位同仁、全体市民们：</p><p>岁聿云暮，一元复始。在这辞旧迎新的美好时刻，金华老年开放大学全体教职工，向始终关心和支持我们发展的各级领导、广大离退休干部、老年朋友和全体市民，致以最衷心的感谢和最诚挚的祝福。</p><p>金华老年开放大学是由市教育局主管的一所综合性老年教育机构，在过去的一年里，是您的支持与信任，照亮了我们前行的道路。每一份付出，每一份收获，都凝聚成我们共同的回忆与硕果，正是您的鼓励与鞭策，激励着我们积极探索，不断超越，为金华社区老年教育事业发展增添了独特的力量。</p><p>新的一年，我们将继续围绕“积极，有为，开放，共享”的办学宗旨，以更饱满的热情，更专业的态度，致力于为广大老年朋友提供更加优质、多元的教育服务，不断创新教学模式，丰富课程内容，努力为老年人建好“家门口”的大学，办好“有温度”的老年开放教育。</p><p>愿新年的钟声敲响幸福的序曲，为您的家庭带来和谐美满，为您的事业插上腾飞的翅膀。愿健康、快乐、成功与您常伴，愿您的每一天都充满阳光与喜悦。</p><p>再次祝愿您及家人新春快乐，身体健康，万事如意，蛇年大吉！</p><p class="end-words">——金华开放大学(金华老年开放大学) 敬上</p>'
        }
        else if (this.$route.query.id == 7) {
            this.mp4_1.sources[0].src = require("../static/m7.mp4")
            this.mp4_1.poster = require("../static/m7.jpg")
            this.words = '<p class="title-words">尊敬的业主家人们、合作伙伴、广大员工及家属：</p><p>值此新春佳节来临之际，浦江万鑫源项目向业主家人、合作伙伴、广大员工及其家属致以节日的问候和新春的祝福！</p><p>万鑫源项目作为省重点招商引资项目，作为开发商的鑫广集团更是精雕细琢，无论从项目规划到落地再到交付使用，一直秉承着高品质原则，将万鑫源项目打造成浦江新标杆！</p><p>万鑫源项目定位于城市综合体，由五星级酒店+商业+高品质住宅组成。五星级万豪喜来登酒店更是成为浦江首家品牌级五星酒店，已于2023年10月开业，并创造多次满房记录和收获了入住客人的不断好评；高品质住宅已于2023年6月交付，获得业主们一致好评，并在一年时间入住率达80%。</p><p>没有最好，只有更好！我们不沉溺于过往取得的成绩，而是更要保持初心，服务好每一位业主、服务好每一位家人，让高品质持续保持和加码！</p><p>新的一年，祝愿万鑫源的广大业主家人们、合作伙伴、员工家人们生活美满，日子红红火火，家庭和和美美，鼠年行大运！</p><p class="end-words">——万鑫源 敬上</p>'
        }
        else if (this.$route.query.id == 8) {
            this.mp4_1.sources[0].src = require("../static/m8.mp4")
            this.mp4_1.poster = require("../static/m8.jpg")
            this.words = '<p class="title-words">尊敬的客户及合作伙伴们：</p><p>大家好，我是柚香谷董事长宋伟，在这辞旧迎新的美好时刻，向金华全市人民致以最诚挚的祝福和最温暖的拥抱！</p><p>过去的一年里，感谢金华市民对柚香谷的支持，在此，我代表柚香谷全体员工衷心感谢大家。</p><p>新的一年里，祝愿国泰民安，风调雨顺。再次祝愿金华全市人民新春快乐，身体健康，金蛇柚福，蛇年大吉！ </p><p class="end-words">——[柚香谷宋柚汁] 敬上</p>'
        }else if (this.$route.query.id == 9) {
            this.mp4_1.sources[0].src = require("../static/m9.mp4")
            this.mp4_1.poster = require("../static/m9.jpg")
            this.words = '<p class="title-words">尊敬的客户及合作伙伴们：</p><p>新春将至，我们向您及家人致以最诚挚的祝福。</p><p>祝您：金龙腾飞，灵蛇运来，巳巳如意，生生不息。</p><p>浙江金义融资租赁有限公司（金义租赁）成立于2022年11月，注册资本3亿元，位于金华市中心，是金华市金投集团有限公司牵头发起的类金融子公司，也是金华地区唯一的国有控股融资租赁法人主体。公司坐落于金华市多湖CBD商务中心的浙中总部经济中心，专注于以设备为基础的金融租赁业务，涵盖售后回租、直接租赁、经营性租赁等。秉承“扎根地方、服务中小、行稳致远”的战略，金义租赁充分发挥融资租赁优势，助力实体经济和民生工程。成立两年来，公司已为数十家企业提供服务，截至2024年12月底，累计投放近17亿元，租赁资产总额超12亿元，实现了快速发展。</p><p class="title-words">如需合作，请联系：</p><p class="title-words">总机：0579-81319698</p><p class="title-words">分机：  0579-81720018</p><p class="title-words">邮编：321000</p><p class="title-words">地址：浙江省金华市多湖中央商务区浙中总部经济中心1号楼26楼。</p>'
        }else if (this.$route.query.id == 10) {
            this.mp4_1.sources[0].src = require("../static/m10.mp4")
            this.mp4_1.poster = require("../static/m10.jpg")
            this.words = '<p class="title-words">尊敬的各级领导、各位校友们：</p><p>金龙腾空去，灵蛇驾云来。在这辞旧迎新的美好时刻，金华市荣光学校向所有关心和支持学校发展的各级领导、社会各界朋友，向辛勤奉献在教育一线的全体教职员工及家属，向追求卓越、自强不息的同学们，向全力配合学校工作的家长朋友，以及一直牵挂母校的荣光校友们，送上最诚挚的新春祝福和由衷的感谢！</p><p>回望2024，时光如诗，步履铿锵。这一年，荣光学校以党的二十届三中全会精神为指引，守正创新、笃行致远，以高质量党建引领学校高质量发展；这一年，全校师生齐心协力、砥砺奋进，教学质量稳步提升，校园环境更加优美，文化氛围日益浓厚；这一年，我们脚踏实地、久久为功，一步一个脚印，把荣光的旗帜插得更高、更稳。</p><p>过去的一年，满载回忆与收获；2025年，承载希望与梦想。我们将以赤诚之心深耕教育沃土，坚定托举每个梦想；以久久为功培育栋梁之才，推动教育振兴力量；以兼容并蓄呵护每份成长，激发学子无限潜能；以勇毅笃行书写荣光篇章，铸就明日灿烂辉煌。</p><p>忠心祝愿荣光师生新年安康、前程似锦！祝愿各级领导、各位朋友事业有成、家庭幸福！祝愿金华热土风调雨顺、欣欣向荣！ 祝愿伟大祖国繁荣昌盛、国泰民安！</p><p class="end-words">——金华市荣光学校 敬上</p>'
        }else if (this.$route.query.id == 11) {
            this.mp4_1.sources[0].src = require("../static/m12.mp4")
            this.mp4_1.poster = require("../static/m12.jpg")
            this.words = '<p class="title-words">尊敬的客户及合作伙伴们：</p><p>在这个辞旧迎新的美好时刻，我们向您致以最诚挚的感谢与祝福。</p><p>项目自6首开热销，稳居区域热度TOP1，冠领金华，耀眼的成绩，离不开每一位客户的支持与厚爱。屡创热销佳绩的背后，是我们对产品非凡品质的不懈坚持与追求。</p><p>滨江城投·和品，占位多湖核芯地段，尽享城市精粹资源的环绕与簇拥。目匠心独运，规划超3000㎡+生活配套，瑰丽奢华的双入户精装大堂，欢趣无限的全龄架空层，假式艺术园林与央景海岛泳池完美融合，以一席臻稀洋房，刷新金华高端人居标准。</p><p>此刻，我们以光阴为笔，在新的起点抒写新的向往，期待与您携手，共迎未来的每一份崭新，与时间同行，听美好作答，新的一年，祈愿您和家人健康如意、幸福美满。</p><p class="end-words">——滨江城投·和品 敬上</p>'
        }else if (this.$route.query.id == 12) {
            this.mp4_1.sources[0].src = require("../static/m11.mp4")
            this.mp4_1.poster = require("../static/m11.jpg")
           this.words = '<p class="title-words">尊敬的客户及合作伙伴们：</p><p>塔尖改善标杆作品，红是众望所归。</p><p>滨江城投·和品项目坐落于多湖核芯，周边凝聚城市最精粹的资源配套，身侧就是约46万方赤山公园，真正一线瞰景，推窗即见浩瀚“后花园”。</p><p>项目匠心打造城芯罕见的低密高端大宅，规划10-11层花园洋房大平层，实景呈现超3000㎡+志趣空间，同频层峯品位。园林雕琢“一轴三进，一心八园”的景观轴线，搭配下沉式叠景庭院，超300米中轴纵深央景，更有海岛泳池，演绎度假生活奢雅格调，每一寸空间，皆为金华塔尖量身定制。</p><p>一席时代珍贵洋房（规划10-11层），进阶主城顶峯生活。滨江城投·和品新品楼栋加推在即，即刻预约！</p><p class="title-words">VIPLIN:0579-8207 6666</p><p class="title-words">春节1月29日-31日（农历初一至初三）期间售楼部暂停接待。2月1日起开始接待， 并有“寻年味 品年趣”系列活动：围炉煮茶、投壶、捶丸等国风休闲互动，诚邀体验春节微度假。</p>'
        }else if (this.$route.query.id == 13) {
            this.mp4_1.sources[0].src = require("../static/m13.mp4")
            this.mp4_1.poster = require("../static/m13.jpg")
           this.words = '<p class="title-words">尊敬的客户及合作伙伴们：</p><p>岁序更替，万象启新。国网（金华）综合能源服务有限公司致力于提供高效、低碳的综合能源服务。值此新春，谨向关心支持我们的各界朋友致以诚挚感谢和美好祝福！祝大家新春快乐、阖家幸福，共赴绿色低碳新征程！</p><p>回望2024，我们迎风雪、跨沟坎、见星辰。这一年，我们矢志不渝地沿循“打基础、上台阶、求突破”的战略脉络，深耕能源交易、能源服务、能源投资领域，全力构建以电为中心的一体化用能产业链，积极推动企事业单位节能降碳改造，全方位开展能源科普志愿服务活动，助力“双碳”目标落地。这一年，我们以创新驱动发展，斩获多项行业奖项，推动技术创新与品牌建设齐头并进，为能源事业注入澎湃动力。</p><p>展望2025，我们将继续坚持“数字牵引+绿色低碳”的发展理念，顺势而为，勇毅奋进，擘画新辉煌！</p><p class="end-words">——国网(金华)综合能源服务有限公司</p><p class="end-words"> 敬上</p>'
        }else if (this.$route.query.id == 14) {
            this.mp4_1.sources[0].src = require("../static/m14.mp4")
            this.mp4_1.poster = require("../static/m14.jpg")
           this.words = '<p class="title-words">尊敬的客户及合作伙伴们：</p><p>岁启新元，福泽满途。中国人寿金华分公司携真挚祝福，愿全市人民蛇年大吉、身心安康、巳巳如意！</p><p> 过去一年，我们陪您抵御风雨，未来也将与您并肩同行。相知多年、值得托付，中国人寿将以更专业、更丰富、更贴心的保险服务，持续为您的生活保驾护航，让每一份美好稳稳落地。</p><p class="end-words">中国人寿金华分公司 敬上</p>'
        }else if (this.$route.query.id == 15) {
            this.mp4_1.sources[0].src = require("../static/m15.mp4")
            this.mp4_1.poster = require("../static/m15.jpg")
           this.words = '<p class="title-words">尊敬的同仁们、朋友们：</p><p>玉龙辞岁，仁心迎春。值此辞旧迎新之际，金华职业技术大学附属医院向关心支持医院发展的各级领导、社会各界朋友、患者及家属们，以及躬耕医圃的全体医护人员，致以最衷心的感谢和最诚挚的问候！</p><p> 2025年开年，金华职业技术大学附属医院，在秀美的湖海塘畔有了全新的工作环境。站在新的起点，我院全体职工将以更蓬勃的朝气、更精湛的技艺、更勤勉的作风，全身心地投入工作，做到眼中有光、心中有梦，为＂健康中国＂战略实施，浙江中西部医疗中心建设，接续奋斗！最后，祝大家新春快乐，身体健康，阖家幸福！</p><p class="end-words">金华职业技术大学附属医院 </p><p class="end-words">金医集团海棠医院 敬上</p>'
        }else if (this.$route.query.id == 16) {
            this.mp4_1.sources[0].src = require("../static/m16.mp4")
            this.mp4_1.poster = require("../static/m16.jpg")
           this.words = '<p>浙江明洁生活服务有限公司成立于 2018 年，公司依托高科技的环保技术以全新的理念推出后勤物业托管、保洁外包、道路清扫、垃圾清运、专业垃圾分类、建筑物清洁等服务。旗下签约制员工已达 1000 余人，这一庞大的团队规模为公司提供了坚实的服务基础。公司凭借着卓越的发展历程，在行业内崭露头角。</p><p class="title-words">2018 年为创立元年，自此开启辉煌历程。</p><p class="title-words">2019 年是发展年，公司在市场中稳步拓展，树立起良好品牌形象。</p><p class="title-words">2020 年聚焦制度建设，完善内部管理体系，保障工作有序。</p><p class="title-words">2021 年大力拓展市场，与众多客户携手合作。</p><p class="title-words">2022 年则以品质为核心，严控服务每一环，给客户极致体验。</p><p class="title-words">2023 年进行改革，积极应对市场变化，优化流程提升效率。</p><p class="title-words">2024年公司将绩效考核于员工激励机制紧密结合，充分调动员工的积极性和创造性，推动公司的持续发展。</p><p>公司成立至今，坚持以人为本，以服务为理念，培养了一支高素质的专业保洁队伍，聚集了一批具有开拓精神，工作认真负责，专业知识扎实的管理团队。明洁作为生活服务行业的知名企业，一直致力于为客户提供高质量的生活服务，以其高质量、专业化的服务宗旨得到了众多合作单位和企业的肯定。让我们携起手来，争创清洁行业高峰！</p><p>选择明洁就是选择最好的！</p>'
        }else if (this.$route.query.id == 17) {
            this.mp4_1.sources[0].src = require("../static/m17.mp4")
            this.mp4_1.poster = require("../static/m17.jpg")
           this.words = '<p class="title-words">尊敬的同仁们、朋友们：</p><p>祥龙辞岁，金蛇迎春。在这新年的序幕即将拉开之际，我们向所有关心并支持婺剧发展的朋友们，致以最诚挚的新年祝福！</p><p>回首过去的一年，我们始终坚持以习近平新时代中国特色社会主义思想为指导，全面贯彻党的二十大和二十届二中、三中全会精神，深入贯彻习近平总书记考察浙江重要讲话精神和考察调研金华重要指示精神，全力推动婺剧事业的发展。在省、市党委政府的正确领导下，在社会各界的关心支持下，婺剧在传承与创新的道路上稳步前行，成果丰硕。</p><p>过去一年，我们全体演职员团结协作，锐意进取，人才队伍日益壮大，艺术精品不断涌现，婺剧的影响力持续扩大。婺剧多次登上国内重要演出舞台，更远赴16个国家访演，向国内外观众展示了婺剧的独特风采，让更多的人了解到中国戏曲文化中的这颗璀璨明珠。</p><p>过去一年，我们积极致力于婺剧艺术的推广与普及。送戏下乡，丰富了农村群众的精神文化生活；走进校园，让婺剧的种子在孩子们心中生根发芽；开展社区文化活动，让文化惠民更深入人心。这些努力使得婺剧的受众群体不断扩大，影响力持续提升。</p><p>新的一年，我们将继续坚守婺剧艺术的传统根基，不断探索创新的表现形式和传播方式。我们将加大对青年演员的培养力度，为婺剧艺术的传承注入新鲜血液。我们也将积极开展与其他艺术形式的交流与合作，博采众长，让婺剧在新时代焕发更加耀眼的光芒。</p><p>我们也希望能够得到各界人士一如既往的支持与关注。戏迷朋友们的每一次鼓掌、每一次喝彩，都是对我们最大的鼓励；社会各界的每一次支持、每一次合作，都是推动婺剧发展的强大动力。让我们携手共进，在新的一年里，让婺剧艺术在传承与创新的道路上越走越远，让更多的人领略到婺剧的无限魅力。</p><p>最后，祝愿大家新年快乐，身体健康，万事如意！愿婺剧艺术在新的一年里蓬勃发展，再创辉煌！</p><p class="end-words">——浙江婺剧艺术研究院</p><p class="end-words">（浙江婺剧团）敬上</p>'
        }else if (this.$route.query.id == 18) {
            this.mp4_1.sources[0].src = require("../static/m18.mp4")
            this.mp4_1.poster = require("../static/m18.jpg")
           this.words = '<p class="title-words">尊敬的客户及合作伙伴们：</p><p>金华华数广电网络有限公司是金华市重点文化企业，是我市唯一的广播电视节目专业传输网络企业。公司始终坚持以人民为中心的工作导向，把群众利益放在首位，践行提供更优质的视听供给、更安全的播出保障、更便捷的智慧服务这一初心和使命。除提供基础的数字电视收视服务外，公司还经营互联网宽带、因特网接入、视频监控、数据专线、智能化信息化工程、云计算、大数据、物联网等业务，是网络覆盖广、传输质量高、业务品种多、服务水平优的智慧广电综合运营商和数字经济服务提供商。</p><p>在过去的一年里，我们坚守信念，锚定方向，为华数的高质量发展勾勒出一幅灿烂的画卷。华数4K超高清电视，带您尽享丰富的全新剧集和热门综艺；华数千兆宽带，性价比卓越，稳定可靠，无任何隐形捆绑；华数智慧家居，提供一站式全屋智能解决方案，让生活更便捷；中国广电192全新号段，700MHz 5G网络，让全家共享高速网络，随心所欲。</p><p>在民生服务领域，我们充分发挥智慧广电和数字化社会的力量，开创性地推出了“智慧广电+民生服务”的新模式。以“一老一小”的需求为导向，我们在居住服务、医疗健康、教育等多个领域深入挖掘创新应用，确保数字经济的成果惠及千家万户，实现真正的普惠共享。</p><p>在应急安全方面，我们借助广电5G技术，大幅提升了灾害事故的检测与感知能力。通过5G+应急广播、安全生产监管的智能化预警和可视化指挥系统，我们助力构建了一个覆盖全方位的灾害事故检测预警网络。</p><p>此外，我们在公安执法、文物安保、校园防霸凌等关键领域，恪尽职守，履行使命，充分体现了华数在推动高质量发展中的责任与担当。我们精准布局，创新融合，为华数的发展注入了源源不断的活力。同时，我们不断提升服务品质，强化内部管理，为华数的高质量发展打下了坚如磐石的基础。</p><p>新的一年，我们将聚焦党建领航、队伍蓄能、管理增效、业务创新、服务提升，在守正创新、实干争先中不断开创高质量发展新局面。</p><p>值此新春佳节来临之际，金华华数广电网络有限公司向全市人民致以最诚挚的节日问候和美好的新年祝愿！愿新年的钟声敲响幸福之门，带来无尽的喜悦与祥和。愿我们的广播电视节目和网络服务，如同春风化雨，滋润每一位用户的心田。</p><p>我们期待与各界同仁携手并进，共同书写金华市数字经济发展的新篇章。衷心祝愿大家新春快乐、身体健康、阖家幸福、万事如意！</p><p class="end-words">——金华华数广电网络有限公司 敬上</p>'
        }
        window.addEventListener("scroll", this.scrolling)
        this.androidplay()
        window.addEventListener("WeixinJSBridgeReady", function onBridgeReady() {


            document.getElementById('audio').volume = 0.2;
            document.getElementById('audio').play();
            document.removeEventListener('WeixinJSBridgeReady', onBridgeReady);

        }, false)
        setTimeout(() => {
            this.thewords = true
        }, 2000);

        setTimeout(() => {
            this.show = true
        }, 5000);
        setTimeout(() => {
            this.showmp4 = true
        }, 4000);
    }

}
</script>

<style lang="less">
.home {
    background: url("../static/homebg.jpg") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 1180px;
    position: relative;

    .music {
        position: fixed;
        width: 40px;
        height: 40px;
        top: 65px;
        right: 20px;
        background: url("../static/music.png") center no-repeat;
        background-size: 100% 100%;
        z-index: 4;

        &.zhuan {
            animation: turn 2s linear infinite;

            @keyframes turn {
                0% {
                    -webkit-transform: rotate(0deg);
                }

                25% {
                    -webkit-transform: rotate(90deg);
                }

                50% {
                    -webkit-transform: rotate(180deg);
                }

                75% {
                    -webkit-transform: rotate(270deg);
                }

                100% {
                    -webkit-transform: rotate(360deg);
                }
            }
        }
    }

    .thegif {
        position: absolute;
        top: -40px;
        width: 100%;
    }

    .title {
        position: absolute;
        top: 70px;
        width: 280px;
        left: 50%;
        margin-left: -130px;
        animation: title_ani 2.5s ease 1 forwards;
        z-index: 5;

        @keyframes title_ani {
            0% {
                width: 360px;
                opacity: 0;

            }

            100% {
                width: 280px;
                opacity: 1;
            }
        }
    }

    .thewords {
        position: absolute;
        width: 180px;
        top: 190px;
        left: 50%;
        margin-left: -90px;

        animation: thewords_ani 2.5s ease 1 forwards;

        @keyframes thewords_ani {
            0% {

                opacity: 0;

            }

            100% {

                opacity: 1;
            }
        }
    }

    .words {
        font-size: 15px;
        width: 280px;
        text-indent: 2em;
        height: 360px;
        overflow: hidden;
        overflow-y: scroll;
        position: absolute;
        color: #797878;
        top: 600px;
        left: 50%;
        margin-left: -140px;
        text-align: justify;
        // font-family:KaiTi;
        font-family: '方正兰亭雅黑';
        animation: words_an 1s ease 1 forwards;


        @keyframes words_an {
            0% {

                opacity: 0;

            }

            100% {

                opacity: 1;
                transform: translate(0);
            }
        }

        .title-words {
            text-indent: 0em;
        }

        .end-words {
            text-align: right;
        }

    }

    .mp4-1 {
        position: absolute;
        width: 300px;
        height: 180px;
        top: 400px;
        left: 50%;
        margin-left: -150px;

        animation: mp4_ani 2s ease 1 forwards;

        @keyframes mp4_ani {
            0% {

                opacity: 0;

            }

            100% {

                opacity: 1;
            }
        }
    }

    .ewm {
        width: 100px;
        position: absolute;
        top: 980px;
        left: 50%;
        margin-left: -50px;
    }

    .tips {
        position: absolute;
        top: 1085px;
        font-size: 14px;
        width: 200px;
        text-align: center;
        left: 50%;
        margin-left: -100px;
    }

    .logo1 {
        position: absolute;
        height: 30px;
        top: 1120px;
        left: 120px;
    }

    .logo {
        position: absolute;
        height: 25px;
        top: 1120px;
        left: 200px;
    }
}
</style>